export default __webpack_public_path__ + "static/media/jupiter_symbol.3fbda87a.png";